import React from "react";
import { Link } from "react-router-dom";
import FacebookIcon from "../../../lib/components/Icons/FacebookIcon";
import InstagramIcon from "../../../lib/components/Icons/InstagramIcon";
import LinkedInIcon from "../../../lib/components/Icons/LinkedInIcon";
import NbyulaLogoIcon from "../../../lib/components/Icons/NbyulaLogoIcon";
import YoutubeIcon from "../../../lib/components/Icons/YoutubeIcon";
import Tooltip from "../../../lib/components/Tooltip";
import Currency from "../../CurrencyModal";
import FooterNbyulaLogo from "../../../lib/components/Icons/FooterNbyulaLogo";

const Footer = ({ wrapperClass = "mt-24" }) => {
  return (
    <div className={wrapperClass}>
      <div className="py-12 px-8 w-full md:px-16 bg-space-20 lg:px-18">
        <div className="flex flex-col justify-between mx-auto max-w-7xl lg:flex-row">
          {/*s left column  */}
          <section className="flex flex-col h-full sm:flex-row sm:space-x-16 lg:space-x-8 xl:space-x-18">
            <div>
              <p className="mb-6 text-sm font-semibold text-space-200">
                Categories
              </p>
              <div className="flex flex-col space-y-4 text-sm font-normal">
                <Link to="/category/study-abroad">Study Abroad</Link>
                <Link to="/category/work-abroad">Work Abroad</Link>
                <Link to="/category/language-preparation">
                  Language Preparation
                </Link>
                <Link to="/category/educational-financing">
                  Education Financing
                </Link>
                <Link to="/category/visa-immigration">Visa & Immigration</Link>
                <Link to="/category/post-landing-support">
                  Post Landing Support
                </Link>
              </div>
            </div>
            <hr className="my-6 md:hidden" />
            <div>
              <p className="mb-6 text-sm font-semibold text-space-200">
                Company
              </p>
              <div className="flex flex-col space-y-4 text-sm font-normal">
                <Link to="/about-us">About</Link>
                <Link to="/contact-us">Contact Us</Link>
                <Link to="/careers">Careers</Link>
                <Link to="/sellers">Become a Mentor</Link>
                <Link to="/terms">Terms & Conditions</Link>
                <Link to="/cancellation-policy">Cancellation Policy</Link>
                <Link to="/shipping-delivery-policy">
                  Shipping & Delivery Policy
                </Link>
                <Link to="/refund-return-policy">Refund & Return Policy</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </div>
            </div>
            <hr className="my-6 md:hidden" />
            <div>
              <p className="mb-6 text-sm font-semibold text-space-200">
                Support
              </p>
              <div className="flex flex-col space-y-4 text-sm font-normal">
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    try {
                      if (window.$chatwoot?.hasLoaded)
                        window.$chatwoot.toggle("open");
                      else
                        window.alert(
                          "Live chat support is not available at the moment. Please write to us at support@nbyula.com"
                        );
                    } catch (error) {}
                  }}
                >
                  Help & Support
                </div>
                <Link to="/community-guidelines">Community Guidelines</Link>
                <Link to="/pricing-policy">Pricing Guidelines</Link>
              </div>
            </div>
          </section>

          <hr className="my-12 lg:hidden" />

          {/* right column  */}
          <section className="flex flex-col">
            <div className="flex items-center mb-4">
              <span className="p-1 mr-2">
                <FooterNbyulaLogo />
              </span>
              <span className="font-semibold">Skillizens without Borders</span>
            </div>
            <div className="ml-3 space-y-12">
              <p className="text-sm lg:w-80">
                Decrypting International study and work paths via tech
                leveraging data & insights from global students & alumni network
              </p>
              <div className="flex items-center -mx-2 h-12 lg:mt-auto">
                <Tooltip title="LinkedIn">
                  <a
                    href="https://www.linkedin.com/company/nbyula"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <LinkedInIcon className="w-11 h-11 text-secondary-dark-300" />
                  </a>
                </Tooltip>
                <Tooltip title="Instagram">
                  <a
                    href="https://www.instagram.com/nbyula/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <InstagramIcon className="w-11 h-11 text-secondary-dark-300" />
                  </a>
                </Tooltip>
                <Tooltip title="Facebook">
                  <a
                    href="https://www.facebook.com/nbyula"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FacebookIcon className="w-11 h-11 text-secondary-dark-300" />
                  </a>
                </Tooltip>
                <Tooltip title="Youtube">
                  <a
                    href="https://www.youtube.com/nbyula"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <YoutubeIcon className="w-11 h-11 text-secondary-dark-300" />
                  </a>
                </Tooltip>
                <Tooltip title="Currency" className="ml-1">
                  <Currency />
                </Tooltip>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Footer;
